import { type RatingAggregates } from "@src/appV2/redesign/Workplace/Review/api/useGetRatingAggregates";

export const REVIEWS_SUMMARY_SCREEN_NAME = "Workplace Reviews Summary";

export const RATING_AGGREGATE_EMPTY: RatingAggregates = {
  numberOfRatings: 0,
  avgRating: 0,
  ratingsBreakdown: [],
};
